import type { RouteObject } from "react-router";

import { LoggedInGuard } from "@/authentication/LoggedInGuard";
import { NotLoggedInGuard } from "@/authentication/NotLoggedInGuard";
import { ErrorPage } from "@/components/Error/ErrorPage";

import { authenticationRoutes } from "./routes";

export const authenticationRoute = [
  {
    path: authenticationRoutes.login,
    lazy: async () => {
      const { SignInSignUpPage } = await import("./pages/SignInSignUpPage");

      return {
        element: (
          <NotLoggedInGuard>
            <SignInSignUpPage />
          </NotLoggedInGuard>
        ),
      };
    },
  },
  {
    path: authenticationRoutes.logout,
    lazy: async () => {
      const { LogoutPage } = await import("./pages/LogoutPage");

      return { element: <LogoutPage /> };
    },
  },
  {
    path: authenticationRoutes.verifyEmail,
    lazy: async () => {
      const { VerifyEmailPage } = await import("./pages/VerifyEmailPage");

      return { element: <VerifyEmailPage /> };
    },
  },
  {
    path: authenticationRoutes.multiFactorAuthentication,
    lazy: async () => {
      const { MultiFactorAuthenticationPage } = await import("./pages/MultiFactorAuthenticationPage");

      return {
        element: (
          <NotLoggedInGuard>
            <MultiFactorAuthenticationPage />
          </NotLoggedInGuard>
        ),
      };
    },
  },
  {
    path: authenticationRoutes.forgotPassword,
    lazy: async () => {
      const { ForgotPasswordPage } = await import("./pages/ForgotPasswordPage");

      return {
        element: (
          <NotLoggedInGuard>
            <ForgotPasswordPage />
          </NotLoggedInGuard>
        ),
      };
    },
  },
  {
    path: authenticationRoutes.resetPassword,
    lazy: async () => {
      const { ResetPasswordPage } = await import("./pages/ResetPasswordPage");

      return { element: <ResetPasswordPage /> };
    },
  },
  {
    path: authenticationRoutes.magicLinkSent,
    lazy: async () => {
      const { MagicLinkSentPage } = await import("./pages/MagicLinkSentPage");

      return { element: <MagicLinkSentPage /> };
    },
  },
  {
    path: authenticationRoutes.magicLink,
    lazy: async () => {
      const { MagicLinkCallbackPage } = await import("./pages/MagicLinkCallbackPage");

      return { element: <MagicLinkCallbackPage /> };
    },
  },
  {
    path: authenticationRoutes.magicLinkEnterCode,
    lazy: async () => {
      const { MagicLinkEnterCodePage } = await import("./pages/MagicLinkEnterCodePage");

      return { element: <MagicLinkEnterCodePage /> };
    },
  },
  {
    path: authenticationRoutes.oauth,
    lazy: async () => {
      const { OAuthAuthorizationPage } = await import("./pages/OAuthAuthorizationPage");

      return {
        element: (
          <LoggedInGuard>
            <OAuthAuthorizationPage />
          </LoggedInGuard>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
